import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { RenderedService } from "../../rendered.service";
import * as moment from "moment";
import "moment-timezone";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-date-display",
  templateUrl: "./date-display.component.html",
  styleUrls: ["./date-display.component.scss"],
})
export class DateDisplayComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  date;
  momentDate;
  private _displayDate: moment.Moment;
  set displayDate(v: moment.Moment) {
    console.log(v);
    this._displayDate = v;
  }
  get displayDate(): moment.Moment {
    return this._displayDate;
  }
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  local;
  is_local = true;
  format = "MM/d/yyyy h:mm a";
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    if (this.item.data && Array.isArray(this.item.data)) {
      for (let i = 0; i < this.item.data.length; i++) {
        const dataItem = this.item.data[i];
        if (dataItem.name && dataItem.name.indexOf("timezone") !== -1) {
          this.timezone = dataItem.value;
          this.is_local = false;
        }
      }
    }
    if (!this.timezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    if (this.item.date_format && this.item.date_format !== "") {
      this.format = this.item.date_format;
    }
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        this.update();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  /**
   * Convert time stampe to local or course time
   * */
  calcTime() {
    // if the date is set
    if (this.date) {
      console.log(this.date);
      // convert stored UTC string to moment date
      this.momentDate = moment.utc(this.date);
      console.log(this.momentDate.format("MM DD YYYY LT"));
      let date = this.momentDate;
      // if the course timezone is set
      if (!this.timezone) {
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
      console.log("setting timezone", this.timezone);
      // convert utc string to moment in the correct timezone
      date = moment.utc(this.date).tz(this.timezone);

      console.log(date.format("MM DD YYYY LT"));
      // convert time to local moment with the same time value so it can be displayed in HTML
      const local = moment(date.format("MM DD YYYY LT"), "MM DD YYYY LT");
      //if (!this.displayDate) {
      this._displayDate = local;
      // }
    } else {
      this._displayDate = undefined;
    }
  }

  update() {
    console.log("UPDATING DATE", this.value);
    this.date = this.value;
    if (this.item.data && Array.isArray(this.item.data)) {
      for (let i = 0; i < this.item.data.length; i++) {
        const dataItem = this.item.data[i];
        if (dataItem.name && dataItem.name.indexOf("timezone") !== -1) {
          this.timezone = dataItem.value;
        }
      }
    }
    this.calcTime();
    if (this.data) {
      const dataKeys = Object.keys(this.data);

      if (this.item.data && Array.isArray(this.item.data)) {
        for (let i = 0; i < this.item.data.length; i++) {
          const dataItem = this.item.data[i];

          for (let j = 0; j < dataKeys.length; j++) {
            if (dataItem.name === dataKeys[j]) {
              const newTimezone = this.data[dataKeys[j]];
              if (this.timezone !== newTimezone) {
                this.timezone = newTimezone;
                this.calcTime();
              }
            }
          }
        }
      }
    }
    this.cdr.detectChanges();
  }

  dateChanged(event, data, key) {
    setTimeout(() => {
      this.item.value = key;
      console.log(event);
      data[key] = event;
    });
  }
}
